<template>
  <div id="Cadastro">
    <router-view v-on:fire-toast="handleToast" v-on:muda-parcela="mudaParcela"></router-view>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import axios from 'axios'
import './Cadastro.css'

export default {
  name: 'Cadastro',
  data () {
    return {
      policyNumber: null,
      handleAcc: true,
      precoPromo: null,
      routeActive: '#/cadastro',
      toast: false,
      error: '',
      generalConditionsUrl: '',
      precoDefault: null,
      fullPayment: [],
      parcialPayment: [],
      mobile: false,
      somenteRoubo: false,
      multiplier: '',
      promoCode: {
        code: null,
        applied: false,
        error: null
      },
      rota: true,
      precoTotal: null,
      promoClass: false,
      items: [
        {
          text: '1- Dados Pessoais',
          disabled: false
        },
        {
          text: '2- Endereço',
          disabled: true
        },
        {
          text: '3- Pagamentos',
          disabled: true
        }
      ],
      phoneData: {},
      priceFull: ''
    }
  },
  mounted () {
    axios.get(
      `${process.env.VUE_APP_API_URL}/internal-cell-phones/v1/phones/${this.device.uuid}`,
      JSON.parse(sessionStorage.config)
    )
    .then(response => {
      if (!response.data || !response.data.DEFAULT || !response.data.PROMO) {
        this.$sentry.logWithContext({
          ctx: { step: '[step/register]: erro no response', data: response.data },
          error: new Error('[step/register]: erro no response')
        })
        return
      }

      this.mountDetails(response.data)
    })

    this.mobile = window.screen.width <= 450
    this.generalConditionsUrl = process.env.VUE_APP_CHICO_XAVIER
    this.policyNumber = this.device.payment.policyNumber
    this.multiplier = sessionStorage.getItem('multiplier')
  },
  computed: {
    ...mapState(['device']),
    valueDefault () {
      return this.precoDefault && `R$ ${this.precoDefault[this.device.payment.installment - 1].preco.replace('.', ',')}`
    },
    valuePromo () {
      return `R$ ${this.device.parcelasPrecos[this.device.payment.installment - 1].replace('.', ',')}`
    }
  },
  methods: {
    handleToast (data) {
      if (data.status === 500) {
        this.error = 'Ocorreu um erro interno ao processar seu pagamento, por favor, tente novamente.'
      } else if (data.status === 400) {
        this.error = data.message
      } else if (data.status === 429) {
        this.error = 'Não foi possível validar seu cartão no momento.'
      }
      this.toast = true
      setTimeout(() => {
        this.toast = false
      }, 10000)
    },
    mudaParcela (event) {
      this.device.parcela = event
      this.device.preco = this.device.parcelasPrecos[event - 1]
      sessionStorage.setItem('device', JSON.stringfy(this.device))
    },
    mountDetails (data) {
      this.$store.commit('phoneDetail', data.DEFAULT)

      this.fullPayment = []
      this.parcialPayment = []
      this.somenteRoubo = this.device.somenteRoubo

      this.deviceDetails = data.DEFAULT
      this.deviceDetails.completePaymentOptions.map((cell, index) => {
        return this.fullPayment.push({ parcela: index + 1, preco: cell })
      })

      this.deviceDetails.theftPaymentOptions.map((cell, index) => {
        return this.parcialPayment.push({ parcela: index + 1, preco: cell })
      })

      this.precoDefault = this.somenteRoubo
        ? this.parcialPayment
        : this.fullPayment

      if (data.PROMO) {
        this.$store.commit('phoneDetail', data.PROMO)

        this.fullPayment = []
        this.parcialPayment = []
        this.deviceDetails = data.PROMO

        this.deviceDetails.completePaymentOptions.map((cell, index) => {
          return this.fullPayment.push({ parcela: index + 1, preco: cell })
        })

        this.deviceDetails.theftPaymentOptions.map((cell, index) => {
          return this.parcialPayment.push({ parcela: index + 1, preco: cell })
        })

        this.precoPromo = this.somenteRoubo
          ? this.parcialPayment
          : this.fullPayment

        this.promoClass = true
      }
    }
  }
}
</script>
